import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Component/Header';
import Header2 from './Component/Header2';
import Footer from './Component/Footer';
import Home from './Pages/Home';
import BlogDetails from './Pages/BlogDetails';
import Contact from './Pages/Contact';
import CategoryPage from './Pages/CategoryPage';
import NotFound from './Pages/NotFound';
import AboutUs from './Pages/AboutUs';
import SubCategoryPage from './Pages/subCategory';
import SearchResults from './Pages/SearchResult';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsAndConditions from './Pages/TermsandConditions';
import { HomeProvider } from './Context/HomeContext';
import './App.css';
import { useHomeDataLoader } from './Hooks/useHomeDataLoader';

// ✅ Create a wrapper component inside the provider
const AppRoutes = () => {
  useHomeDataLoader(); // ✅ Safe to use here

  return (
    <>
    
      <Header />
      <Header2 />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog/:slug" element={<BlogDetails />} />
        <Route path="/ContactUs" element={<Contact />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/category/:slug" element={<CategoryPage />} />
        <Route path="/subcategory/:slug" element={<SubCategoryPage />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
    </>
  );
};

function App() {
  return (
    <HomeProvider>
      <Router>
        <AppRoutes />
      </Router>
    </HomeProvider>
  );
}

export default App;
